module.exports = __webpack_public_path__ + "img/kongzi big (2).4ac56c36.jpg";